import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { ServiceValues } from '../../../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../../../services/ServiceEW';
import { useStyles } from './ModalidadeGeralStyles';
import Typography from '@material-ui/core/Typography';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ModalidadeDetalhes from '../ModalidadeDetalhes/ModalidadeDetalhes';

function ModalidadeGeral(props) {
  const {
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    edicao,
    visitaFiliado,
    setVisitaFiliado,
    indexModalidade,
    armas,
    insumos,
    pacotes
  } = props;
  const classes = useStyles();
  const [expandedModalidade, setExpandedModalidade] = useState();
  const [expandedDetalhes, setExpandedDetalhes] = useState();



  const handleChange = panel => (event, isExpanded) => {
    setExpandedModalidade(isExpanded ? panel : false);
  };

  return (
    <Grid
      container
    >
      <Grid
        md={12}
        xs={12}
      >
        <ExpansionPanel
          expanded={expandedModalidade === 'panel1'}
          onChange={handleChange('panel1')}
          variant={'elevation'}
          style={{
            marginRight: 15,
            marginLeft: 15,
            marginBottom: 15
          }}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>{visitaFiliado.visitaFiliadoMods[indexModalidade].modalidade.descricao}</Typography>
            <Typography className={classes.secondaryHeading}>{'Acompanhamento de detalhes para modalidade ' + visitaFiliado.visitaFiliadoMods[indexModalidade].modalidade.descricao}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
          <Grid
              container
            >
              <Grid
                item
                md={12}
                xs={12}
              >
                  <ModalidadeDetalhes
                    visitaFiliado={visitaFiliado}
                    setVisitaFiliado={setVisitaFiliado}
                    expandedDetalhes={expandedDetalhes}
                    setExpandedDetalhes={setExpandedDetalhes}
                    indexModalidade={indexModalidade}
                    indexVisitaFiliadoTrap={0}
                    setShowMessageSnack={setShowMessageSnack}
                    setMessageSnack={setMessageSnack}
                    setTypeSnack={setTypeSnack}
                    setLoading={setLoading}
                    armas={armas}
                    insumos={insumos}
                    pacotes={pacotes}
                  />
              </Grid>
            </Grid>
          </ExpansionPanelDetails>

        </ExpansionPanel>
      </Grid>

    </Grid>
  );
}

ModalidadeGeral.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default ModalidadeGeral;


